import { useState } from 'react';

import { HorizontalContainer, Wrapper } from '@american-autonomy/ag-ui';

import SearchInput from 'components/SearchInput';
import CloseIcon from 'components/icons/CloseIcon';

import useTranslation from './hooks/useTranslation';

import { SEARCH_DEBOUNCE_TIME_MS, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const SearchFilters: FunctionComponent<Props> = ({
    className = '',
    onSearch,
    placeholder,
    testId = TEST_ID
}) => {
    const { SEARCH_PLACEHOLDER } = useTranslation();

    const [searchValue, setSearchValue] = useState('');
    const [searchKey, setSearchKey] = useState(0);

    const handleSearch = async (searchTerm: string) => {
        onSearch?.(searchTerm);
    };

    const handleClearSearch = () => {
        setSearchValue('');
        setSearchKey(previous => previous + 1);
        onSearch?.('');
    };

    return (
        <HorizontalContainer className={`${className} ${styles.searchFilters}`} testId={testId}>
            <SearchInput
                className={styles.searchInput}
                debounceTime={SEARCH_DEBOUNCE_TIME_MS}
                key={searchKey}
                onChange={setSearchValue}
                onFilter={handleSearch}
                placeholder={placeholder || SEARCH_PLACEHOLDER}
            />

            {searchValue ? (
                <Wrapper className={styles.wrapper} onClick={handleClearSearch}>
                    <CloseIcon className={styles.closeIcon} />
                </Wrapper>
            ) : null}
        </HorizontalContainer>
    );
};

export default SearchFilters;
